import type { CategoryViewProps } from '../../types';
import * as React from 'react';
import { CollectionC as CollectionComponent } from '../../containers/CollectionC';

export function View(props: CategoryViewProps) {
  return (
    <>
      <CollectionComponent {...props} />
    </>
  );
}
